module.exports = __webpack_public_path__ + "static/media/29r.b634095e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Deconstructed/29r.JPG
// module id = 325
// module chunks = 0